import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Accordion, ToastContainer } from "react-bootstrap";
import {
  ArrowClockwise,
  FilterCircle,
  Wifi,
  WifiOff,
} from "react-bootstrap-icons";
import useDash from "../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import Loader from "../../components/common/Loader";
import { useEffect } from "react";
import {
  getMikrotik,
  getStaticActiveCustomer,
} from "../../features/apiCallReseller";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../components/table/Table";
import NetFeeBulletin from "../../components/bulletin/NetFeeBulletin";
import Footer from "../../components/admin/footer/Footer";
import { getBulletinPermission } from "../../features/apiCallAdmin";
import { badge } from "../../components/common/Utils";

const ActiveStaticCustomer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // get user role
  const role = useSelector((state) => state.persistedReducer.auth?.role);

  // get Isp owner id
  const ispOwnerId = useSelector(
    (state) => state.persistedReducer.auth?.ispOwnerId,
  );

  // get reseller id
  const resellerId = useSelector((state) =>
    role === "reseller"
      ? state.persistedReducer.auth?.userData?.id
      : state.persistedReducer.auth?.userData?.reseller,
  );

  // get all mikrotik from redux
  const mikrotik = useSelector((state) => state?.mikrotik?.mikrotik);

  // get all static customer
  let staticActiveCustomer = useSelector(
    (state) => state?.customer?.staticActiveCustomer,
  );

  // get bulletin permission
  const butPermission = useSelector(
    (state) => state.adminNetFeeSupport?.bulletinPermission,
  );

  // loading state
  const [isLoading, setIsLoading] = useState();

  // filter status state
  const [filterStatus, setFilterStatus] = useState();

  // mikrotikId state
  const [mikrotikId, setMikrotikId] = useState(mikrotik[0]?.id);

  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");

  // select mikrotik handler
  const mikrotiSelectionHandler = (event) => {
    setMikrotikId(event.target.value);
  };

  // filter
  if (filterStatus && filterStatus !== t("sokolCustomer")) {
    staticActiveCustomer = staticActiveCustomer.filter(
      (value) => value.complete === JSON.parse(filterStatus),
    );
  }

  // reload handler
  const reloadHandler = () => {
    getStaticActiveCustomer(
      dispatch,
      ispOwnerId,
      resellerId,
      mikrotikId,
      setIsLoading,
    );
  };

  useEffect(() => {
    setMikrotikId(mikrotik[0]?.id);
  }, [mikrotik]);

  useEffect(() => {
    getMikrotik(dispatch, resellerId);

    if (mikrotikId) {
      getStaticActiveCustomer(
        dispatch,
        ispOwnerId,
        resellerId,
        mikrotikId,
        setIsLoading,
      );
    }
  }, [mikrotikId]);

  useEffect(() => {
    Object.keys(butPermission)?.length === 0 && getBulletinPermission(dispatch);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        width: "5%",
        Header: t("id"),
        accessor: "customerId",
      },
      {
        width: "5%",
        Header: <Wifi />,
        accessor: "complete",
        Cell: ({ value }) => (
          <div>
            {value === true ? <Wifi color="green" /> : <WifiOff color="red" />}
          </div>
        ),
      },
      {
        width: "15%",
        Header: t("name"),
        accessor: "name",
      },
      {
        width: "10%",
        Header: t("ipAddress"),
        accessor: (data) => data?.ipAddress,
        Cell: ({ row: { original } }) => (
          <div style={{ cursor: "pointer" }}>
            <p
              onClick={() =>
                window.open(`http://${original?.ipAddress}`, "_blank")
              }
              style={{
                cursor: "pointer",
                textDecoration: "none",
                color: "inherit",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
                e.currentTarget.classList.add("text-primary");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
                e.currentTarget.classList.remove("text-primary");
              }}
            >
              {original?.ipAddress}
            </p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("macAddress"),
        accessor: "macAddress",
      },
      {
        width: "8%",
        Header: t("upload"),
        Cell: ({ row: { original } }) => (
          <div
            style={{
              padding: "15px 15px 15px 0 !important",
            }}
          >
            {original?.bytes?.split("/")?.[0]
              ? original?.bytes?.split("/")?.[0] / 1024 / 1024 <= 1024
                ? (original?.bytes?.split("/")?.[0] / 1024 / 1024).toFixed(2) +
                  " MB"
                : (
                    original?.bytes?.split("/")?.[0] /
                    1024 /
                    1024 /
                    1024
                  ).toFixed(2) + " GB"
              : ""}
          </div>
        ),
      },
      {
        width: "8%",
        Header: t("download"),
        Cell: ({ row: { original } }) => (
          <div>
            {original?.bytes?.split("/")?.[1]
              ? original?.bytes?.split("/")?.[1] / 1024 / 1024 <= 1024
                ? (original?.bytes?.split("/")?.[1] / 1024 / 1024).toFixed(2) +
                  " MB"
                : (
                    original?.bytes?.split("/")?.[1] /
                    1024 /
                    1024 /
                    1024
                  ).toFixed(2) + " GB"
              : ""}
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("status"),
        accessor: (data) => `${data?.action} ${data.status}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p>{badge(original?.action)}</p>
            <p>{badge(original?.status)}</p>
          </div>
        ),
      },
    ],
    [t],
  );
  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="d-flex">
                    <h2>{t("activeStaticCustomer")}</h2>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          onClick={() => reloadHandler()}
                        ></ArrowClockwise>
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>
              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <div className="d-flex justify-content-center">
                          <div className="mikrotik-filter">
                            <select
                              id="selectMikrotikOption"
                              onChange={mikrotiSelectionHandler}
                              className="form-select mt-0"
                            >
                              {mikrotik.map((item) => (
                                <option value={item.id}>{item.name}</option>
                              ))}
                            </select>
                          </div>
                          <div className="customer-filter ms-4">
                            <select
                              className="form-select mt-0"
                              aria-label="Default select example"
                              onChange={(event) =>
                                setFilterStatus(event.target.value)
                              }
                            >
                              <option selected> {t("sokolCustomer")} </option>
                              <option value={true}> {t("active")} </option>
                              <option value={false}> {t("in active")} </option>
                            </select>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="collectorWrapper pb-2">
                    <div className="table-section">
                      <Table
                        isLoading={isLoading}
                        columns={columns}
                        data={staticActiveCustomer}
                      />
                    </div>
                  </div>
                </div>

                {(butPermission?.activeCustomer || butPermission?.allPage) && (
                  <NetFeeBulletin />
                )}
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveStaticCustomer;
